var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "search_member-popup",
      attrs: { title: "Search & Invite new Members" },
      on: { cancel: _vm.close },
      model: {
        value: _vm.isVisible,
        callback: function($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible"
      }
    },
    [
      _c(
        "a-row",
        { attrs: { type: "flex", gutter: 1 } },
        [
          _c(
            "a-col",
            { attrs: { xs: 18 } },
            [
              _c("a-input", {
                attrs: { type: "email", placeholder: "Enter members email" },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              })
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { xs: 6 } },
            [
              _c(
                "a-button",
                {
                  attrs: { block: "", type: "primary" },
                  on: { click: _vm.searchEmails }
                },
                [_vm._v("Search")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        _vm._l(_vm.members, function(member) {
          return _c(
            "a-row",
            { key: member.user_id, attrs: { type: "flex", gutter: 4 } },
            [
              _c("a-col", { attrs: { span: 6 } }, [
                _vm._v(
                  "\n        " +
                    _vm._s(member.first_name) +
                    " " +
                    _vm._s(member.last_name) +
                    "..\n      "
                )
              ]),
              _c("a-col", { attrs: { span: 12 } }, [
                _vm._v("\n        " + _vm._s(member.work_email) + "\n      ")
              ]),
              _c(
                "a-col",
                { staticClass: "gx-text-right", attrs: { span: 6 } },
                [
                  !member.status ||
                  member.status === "declined" ||
                  member.status === "archived"
                    ? _c(
                        "a-button",
                        {
                          attrs: { block: "", size: "small" },
                          on: {
                            click: function($event) {
                              return _vm.inviteMember(member.id)
                            }
                          }
                        },
                        [_vm._v("\n          Send Invite\n        ")]
                      )
                    : _vm._e(),
                  member.status === "invited" || member.status === "accepted"
                    ? _c(
                        "a-button",
                        { attrs: { type: "danger", block: "", size: "small" } },
                        [
                          member.status === "invited"
                            ? [_vm._v("Invitation Pending")]
                            : _vm._e(),
                          member.status === "archived"
                            ? [_vm._v("Archived")]
                            : _vm._e(),
                          member.status === "accepted"
                            ? [_vm._v("Already a Member")]
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _vm.members.length < 1 && _vm.error_msg
        ? _c("div", { staticClass: "gx-text-center" }, [
            _vm._v("\n    Member not found\n  ")
          ])
        : _vm._e(),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }